var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.5 22.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.38,22.38a.38.38,0,0,1-.38.37H.75a.38.38,0,0,1,0-.75H24A.38.38,0,0,1,24.38,22.38ZM.38,9.75A.37.37,0,0,1,0,9.5a.38.38,0,0,1,.13-.42l11.79-9a.35.35,0,0,1,.45,0l11.73,9a.37.37,0,0,1,.12.42.37.37,0,0,1-.35.25ZM1.48,9h21.3L12.16.85ZM12.39,5a.54.54,0,0,1-.55-.55.55.55,0,0,1,.55-.55.56.56,0,0,1,.55.51.29.29,0,1,0,.57,0,1.12,1.12,0,0,0-.84-1V3.18a.29.29,0,1,0-.57,0v.21a1.12,1.12,0,0,0,.29,2.21.55.55,0,0,1,.55.55.55.55,0,0,1-.55.55.55.55,0,0,1-.55-.55.29.29,0,0,0-.58,0,1.13,1.13,0,0,0,.84,1.08v.21a.29.29,0,1,0,.57,0V7.23A1.12,1.12,0,0,0,12.39,5ZM24.5,11.09a.41.41,0,0,1-.41.41H21.28v8.56h2.6a.41.41,0,1,1,0,.82H.72a.41.41,0,1,1,0-.82h2.8V11.5H.72a.41.41,0,0,1-.41-.41.41.41,0,0,1,.41-.41H24.09A.41.41,0,0,1,24.5,11.09Zm-13.79.41H4.34v8.56H6.21V12.39a.41.41,0,0,1,.82,0v7.67h3.68Zm2.69,0H11.53v8.56H13.4Zm7.06,0H18.58v7.64a.41.41,0,0,1-.41.41.41.41,0,0,1-.41-.41V11.5H14.23v8.56h6.23Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.e4d56fb29baf117ecfe69a178672dd92.svg";
export { ForwardRef as ReactComponent };